export default __webpack_public_path__ + "81beafda08146b3c900fd6da1ffec7e5.png";